export default __webpack_public_path__ + "static/media/paulana-lamonier-640.33a9cfce.jpg";